const state = {
    responsiveScreenWidth: null,
    responsiveIfMobile: false //Если мобильное устройство
};

const getters = {
    responsiveScreenWidth: state => {
      return state.responsiveScreenWidth
    },
    responsiveIfMobile: state => {
      return state.responsiveIfMobile
    }
};

const mutations = {
    responsiveScreenWidth: (state, payload) => {
      return state.responsiveScreenWidth = payload
    },
    responsiveIfMobile: (state, payload) => {
      return state.responsiveIfMobile = payload
    }
};

const actions = {
  responsiveScreenWidth({commit}, payload) {
    commit('responsiveScreenWidth', payload)

    if (payload <= 1024) {
      commit('responsiveIfMobile', true)
    } else {
      commit('responsiveIfMobile', false)
    }
  }
};

export default {
    state,
    getters,
    mutations,
    actions
}